import { EclipseNav } from "@/components/EclipseChrome";

/** Subpage navigation: fixed Eclipse nav, anchors link back to the homepage. */
const Navbar = () => <EclipseNav fixed />;

export default Navbar;
